export default "__VITE_ASSET__BbxZtetZ__"